import GranolaSvg from "@/assets/connectors/granola.svg?react";

/**
 * Granola's mark, for a pulled meeting note.
 *
 * Drawn from `shared/assets/connectors`, the same file native imports — a
 * hand-written copy per platform is what let this mark go missing on web while
 * native had it all along.
 *
 * A saved service object has no connector row and no provider, so it reaches
 * the row as a brand slug rather than as mail or a calendar, which is why it
 * belongs in `brandProviderIcons`.
 */
export const GranolaIcon = ({ className }: { className?: string }) => (
  <GranolaSvg role="img" aria-label="Granola" className={className} />
);
